import React from 'react';
import {Stack} from '@mui/material';
import PIRList from "../../IR/page/PIRList";
import PIRHeader from "./PIRHeader";

/**
 * Renders a list of Priority Intelligence Requirements (PIRs).
 * Subscribes to all PIRs when no parentIr is provided.
 */
const ListOfPriorityIntelligenceRequirements = () => {

    return (
        <Stack p={2} spacing={2} overflow={'auto'}>
            <PIRHeader/>
            <PIRList/>
        </Stack>
    );
};

export default ListOfPriorityIntelligenceRequirements;